import {
  Select,
  SelectContent,
  SelectGroup,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/shared/ui/select';
import { Language } from '@/shared/utils';

type LanguageSelectProps = {
  onValueChange: (value: Language) => void;
  value: Language;
};

export const LanguageSelect = ({ onValueChange, value }: LanguageSelectProps) => {
  return (
    <Select value={value} onValueChange={onValueChange}>
      <SelectTrigger className="w-[130px]">
        <SelectValue />
      </SelectTrigger>

      <SelectContent>
        <SelectGroup>
          <SelectItem value="en">English</SelectItem>
          <SelectItem value="ua">Українська</SelectItem>
        </SelectGroup>
      </SelectContent>
    </Select>
  );
};
